import { Link } from '@tanstack/react-router';

type Tone = 'light' | 'dark';

interface BrandLockupProps {
  tone?: Tone;
  showSlogan?: boolean;
}

export function BrandLockup({ tone = 'light', showSlogan = true }: BrandLockupProps) {
  const wordClass = tone === 'dark' ? 'text-brand-cream' : 'text-brand-ink-soft';
  const sloganClass = tone === 'dark' ? 'text-brand-sage-light' : 'text-brand-sage';

  return (
    <Link
      to="/"
      aria-label="Bookaburra home"
      className="inline-flex items-center gap-2.5"
    >
      <img
        src="/logos/bookaburra-mark.svg"
        alt=""
        aria-hidden="true"
        className="h-10 w-10 shrink-0"
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-extrabold tracking-[-0.04em] ${wordClass} text-[1.72rem] sm:text-[1.95rem]`}
        >
          Bookaburra
        </span>
        {showSlogan ? (
          <span
            className={`mt-1 hidden text-[0.72rem] font-medium leading-none tracking-[0.01em] ${sloganClass} sm:block`}
          >
            Smart booking for service providers
          </span>
        ) : null}
      </span>
    </Link>
  );
}
